import { normalizeLocale } from "@/shared/lib/locale"
import { resolveReviewTranslationKey } from "@/entities/hospital/lib/review-translation"

/**
 * 병원 리뷰 무한스크롤 캐시 키.
 *
 * 서버 prefetch(setQueryData)와 클라 훅이 **반드시 이 함수 하나만** 써야 한다.
 * 키가 어긋나면 hydrate가 적용되지 않아 초기 HTML에 실은 리뷰를 클라가 버리고 다시 받는다.
 *
 * 마지막 칸이 로케일인 이유: 이제 payload가 로케일별로 다르게(표시용 + ko만) 축소되므로
 * 로케일 없는 한 칸을 공유하면 최신 ko 캐시가 다른 로케일의 hydrate를 막아
 * 본문이 한국어로 떨어지고 원문 토글이 사라진다.
 * 로케일 문자열 자체가 아니라 표시 번역 키를 쓰는 이유는 그것이 payload가 갈리는 실제 축이기 때문이다.
 *
 * 정규화(`normalizeLocale`)를 **빌더 안에서** 한다. 서버는 이미 정규화한 값을,
 * 클라는 경로 세그먼트를 날것으로 넘기므로 바깥에서 각자 전처리하면
 * 미지원 입력(`fr`·`ja`·대문자 등)에서 서버 `ko`, 클라 `en`/`jp` 로 갈린다.
 * `normalizeLocale` 은 멱등이라 정규화된 값을 다시 넣어도 같은 결과다.
 */
/**
 * 클라가 넘기는 경로 세그먼트는 인코딩된 채로 올 수 있다(`/%65n/hospital/…`).
 * 서버는 프레임워크가 한 번 디코드한 라우트 파라미터를 보므로 여기서 한 번만 맞춰 준다.
 * 잘못된 인코딩(`%zz`)은 디코드할 수 없으니 원문을 그대로 두고 정규화가 기본값으로 떨구게 한다.
 */
const decodeLocaleSegment = (locale: string): string => {
  try {
    return decodeURIComponent(locale)
  } catch {
    return locale
  }
}

export const hospitalReviewQueryKey = (
  hospitalOriginId: number,
  sort: string,
  locale: string,
) => [
  "hospitalReview",
  hospitalOriginId,
  sort,
  resolveReviewTranslationKey(normalizeLocale(decodeLocaleSegment(locale))),
] as const
